<template>
  <div>
    <nav aria-label="breadcrumb" class="breadcrumb-nav border-0 mb-0">
      <div class="container d-flex align-items-center">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/dashboard">Home</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="'/casi-clinici/show/' + formClinicalCase.slug">Torna al caso</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Aggiorna</li>
        </ol>
      </div>
      <!-- End .container -->
    </nav>
    <h4 class="checkout-title text-center mt-0 mb-2" style="font-size: 3.2rem">
      Aggiorna il caso clinico
    </h4>
    <div class="checkout">
      <div class="container">
        <div class="row pb-4">
          <div class="col-lg-12">
            <LoadedComponent :loading="loading" />

            <AlertComponent :message="success" :alert-type="'success'" />
            <AlertComponent :message="errorMessage" :alert-type="'danger'" />

            <ul class="nav nav-tabs nav-tabs-bg" id="tabs-1" role="tablist" v-if="!loading">
              <li class="nav-item">
                <a class="nav-link active" id="tab-1-tab" data-toggle="tab" href="#tab-1" role="tab"
                  aria-controls="tab-1" aria-selected="true">Dati del caso</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="tab-2-tab" data-toggle="tab" href="#tab-2" role="tab" aria-controls="tab-2"
                  aria-selected="true">Ordinamento allegati</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="tab-3-tab" data-toggle="tab" href="#tab-3" role="tab" aria-controls="tab-3"
                  aria-selected="true">Carica allegati</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="tab-4-tab" data-toggle="tab" href="#tab-4" role="tab" aria-controls="tab-3"
                  aria-selected="true">Carica la copertina</a>
              </li>
            </ul>

            <div class="tab-content tab-content-border" id="tab-content-1" v-if="!loading">
              <div class="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="tab-1-tab">
                <form class="pt-2 pr-4 pl-4" id="form-date-submit" @submit.prevent="update_clinical_case">
                  <h4 class="pb-2">
                    <small>
                      Inserisci o aggiorna le informazioni del tuo caso e fai
                      click nel bottone in basso a destra "Salva le info" per
                      memorizzare
                    </small>
                  </h4>
                  <div class="row">
                    <div class="col-sm-12">
                      <label for="nome_caso">Nome del caso *</label>
                      <input type="text" class="form-control" name="nome" id="nome_caso"
                        placeholder="Aggiorna il nome del caso" v-model="formClinicalCase.name" />

                      <div class="alert alert-danger" v-if="errors.name">
                        {{ errors.name[0] }}
                      </div>
                    </div>
                    <!-- End .col-sm-6 -->

                    <div class="col-md-4">
                      <label for="categorie_mediche_edit" class="form-label">Categoria *</label>
                      <select class="form-control" id="categorie_mediche_edit" name="id_categoria_medica"
                        v-model="formClinicalCase.category_medical_id" readonly>
                        <option v-for="category in categoryMedical" :key="category.id" :value="category.id">
                          {{ category.name }}
                        </option>
                      </select>

                      <div class="alert alert-danger" v-if="errors.category_medical_id">
                        {{ errors.category_medical_id[0] }}
                      </div>
                    </div>

                    <div class="col-md-4">
                      <label for="patologia_edit" class="form-label">Patologia *</label>
                      <select class="form-control" id="patologia_edit" name="id_patologia"
                        v-model="formClinicalCase.patology_id" required>
                        <option v-for="patology in patologies" :key="patology.id" :value="patology.id">
                          {{ patology.name }}
                        </option>
                      </select>

                      <div class="alert alert-danger" v-if="errors.patology_id">
                        {{ errors.patology_id[0] }}
                      </div>
                    </div>

                    <div class="col-md-4">
                      <label for="distretto_anatomico" class="form-label">Distretto Anatomico *</label>
                      <select class="form-control" id="distretto_anatomico" name="id_distretto"
                        v-model="formClinicalCase.anatomical_district_id" required>
                        <option v-for="anatomical in anatomicalDistrict" :key="anatomical.id" :value="anatomical.id">
                          {{ anatomical.name }}
                        </option>
                      </select>

                      <div class="alert alert-danger" v-if="errors.anatomical_district_id">
                        {{ errors.anatomical_district_id[0] }}
                      </div>
                    </div>

                    <div class="col-md-12">
                      <label for="descrizione">Descrizione del post *</label>
                      <textarea class="form-control" id="descrizione" rows="3" name="descrizione"
                        placeholder="Spiegazione del tuo post" v-model="formClinicalCase.description"></textarea>

                      <div class="alert alert-danger" v-if="errors.description">
                        {{ errors.description[0] }}
                      </div>
                    </div>

                    <div class="col-sm-12" v-if="formClinicalCase.category_medical_id == 3">
                      <label for="" class="form-label">Utenti a cui notificare il caso *</label>
                      <Select2 v-model="formClinicalCase.notifications" :options="users" :settings="{
                        multiple: true,
                        selectionCssClass: 'w-100',
                      }" :placeholder="'Seleziona gli utenti'" />
                      <div class="alert alert-danger" v-if="errors.notifications">
                        {{ errors.notifications[0] }}
                      </div>
                    </div>
                  </div>

                  <div class="row flex-column pb-2 pl-2 pr-2">
                    <div class="flex-row mt-4">
                      <button type="submit" class="btn btn-primary float-right">
                        Salva le info <i class="las la-save"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>

              <div class="tab-pane fade show" id="tab-2" role="tabpanel" aria-labelledby="tab-2-tab">
                <div class="row pt-4 pr-4 pl-4">
                  <div class="col-md-12">
                    <h2 class="checkout-title" style="font-size: 2rem">
                      Ordinamento file <br /><small>PER ORDINARE I FILE CLICCA E TRASCINA IL FILE
                        NELL’ORDINE DESIDERATO.</small>
                    </h2>
                    <form @submit.prevent="save_order">
                      <ul ref="sortableList" class="list-group">
                        <li v-for="(item, index) in attachments" :key="item.id" class="list-group-item mb-2">
                          <div class="float-right d-flex align-items-center">
                            <button type="btn btn-link " @click="deleteAttachment(item.id, index)">
                              Elimina il file
                            </button>
                          </div>
                          <input type="hidden" name="order[]" class="order_class" v-model="item.id" />
                          <div class="row">
                            <input type="text" :value="item.name" :id="'attachments-rename-' + item.id"
                              class="form-control w-50" />
                            <button type="button" class="btn btn-link text-dark ml-2" @click="rename(item.id)">
                              <i class="las la-pen-fancy"></i> Rinonima
                            </button>
                          </div>
                        </li>
                      </ul>
                      <div class="row flex-column pb-2 pl-2 pr-2">
                        <div class="flex-row">
                          <button type="submit" class="btn btn-primary float-right">
                            Salva l'ordinamento <i class="las la-save"></i>
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div class="tab-pane fade show" id="tab-3" role="tabpanel" aria-labelledby="tab-3-tab">
                <div class="row pt-4 pr-4 pl-4">
                  <div class="col-md-12">
                    <h2 class="checkout-title" style="font-size: 2rem">
                      Carica allegati <br /><small>Seleziona i tuoi file e confermali facendo click su
                        "Invia file"</small>
                    </h2>
                    <!-- End .checkout-title -->
                    <form @submit.prevent="upload_attachments">
                      <div class="input-group mb-3">
                        <div class="custom-file">
                          <input type="file" class="custom-file-input" name="files[]" ref="fileInput"
                            @change="handleFileUpload" id="fileInput" aria-describedby="inputGroupFileAddon01"
                            multiple />
                        </div>
                        <label class="custom-file-label text-center labels-files" for="fileInput" id="labelsfiles">{{
                          nameFiles }}
                        </label>
                      </div>

                      <!--d-none -->
                      <a href="#tab-1" id="cover-neurohub" class="btn btn-link d-none" role="tab" aria-controls="tab-1"
                        aria-selected="true" data-toggle="tooltip" data-placement="left"
                        title="Puoi ricontrallare i dati del tuo caso e scegliere una copertina fra le immagini che hai appena caricato">Fra
                        le immagini che hai appena caricato vuoi dare una
                        copertina al caso clinico? Se si clicca qui.</a>
                      <div class="row flex-column pb-2 pl-2 pr-2">
                        <div class="flex-row">
                          <button type="submit" class="btn btn-primary float-right">
                            Salva i nuovi file <i class="las la-save"></i>
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade show" id="tab-4" role="tabpanel" aria-labelledby="tab-4-tab">
                <div class="row pt-4 pr-4 pl-4">
                  <div class="col-md-12">
                    <h2 class="checkout-title" style="font-size: 2rem">
                      Carica la copertina del caso <br /><small>Seleziona il tuo file
                      </small>
                    </h2>
                    <!-- End .checkout-title -->
                    <form>
                      <div class="input-group mb-3">
                        <div class="custom-file">
                          <input type="file" class="custom-file-input" name="cover" ref="fileInputCover"
                            @change="handleFileUploadCover" id="fileInputCover"
                            aria-describedby="inputGroupFileAddon01" />
                        </div>
                        <label class="custom-file-label text-center labels-files" for="fileInputCover"
                          id="labelsfiles">{{ nameFiles }}
                        </label>
                      </div>

                      <div class="d-flex justify-content-center" v-if="coverAttachment !== null">
                        <img :src="coverAttachment.path" :alt="coverAttachment.name" class="img-thumbnail" />
                      </div>
                      <div class="text-center mt-2" v-if="coverAttachment !== null">
                        <button type="button" class="btn btn-danger" @click="deleteAttachment(this.coverAttachment.id)">
                          <i class="las la-trash"></i>
                        </button>
                      </div>

                      <!--d-none -->
                      <a href="#tab-1" id="cover-neurohub" class="btn btn-link d-none" role="tab" aria-controls="tab-1"
                        aria-selected="true" data-toggle="tooltip" data-placement="left"
                        title="Puoi ricontrallare i dati del tuo caso e scegliere una copertina fra le immagini che hai appena caricato">Fra
                        le immagini che hai appena caricato vuoi dare una
                        copertina al caso clinico? Se si clicca qui.</a>
                      <div class="row flex-column pb-2 pl-2 pr-2">
                        <div class="flex-row"></div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httpauth from "@/services/httpauth.js";
import LoadedComponent from "@/components/LoadedComponent.vue";
import httpservices from "@/services/httpservices.js";
import Select2 from "vue3-select2-component";
import Sortable from "sortablejs";
import $ from "jquery";
import { useAuth } from "@/stores/auth.js";
import AlertComponent from "@/components/AlertComponent.vue";
window.jQuery = $;
window.$ = $;
import router from "@/router";
import { useToast } from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
export default {
  name: "UpdateClinicalCase",
  props: ["slug"],
  components: {
    Select2,
    LoadedComponent,
    AlertComponent,
  },
  data() {
    return {
      loading: true,
      nameFiles: "Scegli i file (MAX 1 GIGA)",
      patologies: [],
      categoryMedical: [],
      anatomicalDistrict: [],
      attachments: [],
      attachmentsRename: [],
      selectedFiles: {},
      coverAttachment: null,
      users: [],
      errors: [],
      coverPath: "",
      errorMessage: "",
      success: "",
      formClinicalCase: {},
      request: {
        model: "activity",
        model_id: 0,
      },
    };
  },
  mounted() {
    this.getClinicalCase();
    this.fetchPatology();
    this.fetchAtomicalDistrict();
  },
  created() { },
  methods: {
    async fetchCategoryMedical() {
      await httpservices
        .getCategoryMedical()
        .then((response) => {
          if (this.formClinicalCase.category_medical_id == 3)
          {
            for (var i = 0; i < response.data.data.length; i++)
            {
              if (response.data.data[i].id == 3)
              {
                this.categoryMedical.push(response.data.data[i]);
              }
            }
          } else
          {
            this.categoryMedical = response.data.data;
          }
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async fetchPatology() {
      await httpservices
        .getPatology()
        .then((response) => {
          this.patologies = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async fetchAtomicalDistrict() {
      await httpservices
        .getAnatomicalDistrict()
        .then((response) => {
          this.anatomicalDistrict = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async save_order() {
      var orders = [];
      $(".order_class").each(function () {
        var value = $(this).val();
        orders.push(value);
      });
      const formReorder = {
        model: "activity",
        model_id: this.formClinicalCase.id,
        order: orders,
      };

      httpauth
        .post("/attachments/reorder", formReorder)
        .then((response) => {
          this.success = response.data.message;
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async getClinicalCase() {
      await httpauth
        .get("/casi-clinici/edit/" + this.slug, [
          {
            params: { slug: this.slug }, // Passa l'ID come oggetto nel campo 'data'
          },
        ])
        .then((response) => {
          var data = response.data.data;
          this.formClinicalCase = data;

          this.loadAttachment(this.formClinicalCase.id);
          if (this.formClinicalCase.category_medical_id == 3)
          {
            this.formClinicalCase.notifications =
              response.data.data.notifications.user;
            this.fetchUsers();
          } else
          {
            this.formClinicalCase.notifications = [];
          }
          this.fetchCategoryMedical();
          this.loading = false;
          // Gestisci l'array di oggetti come desiderato
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
          this.errors = error.response.data.errors;
        });
    },
    async rename(id) {
      const form = {
        id: id,
        name: document.getElementById("attachments-rename-" + id).value,
      };
      await httpauth
        .post("/attachments/rename", form)
        .then((response) => {
          const $toast = useToast();
          $toast.open({
            message: response.data.message,
            type: "info",
            position: "top-right",
            // all of other options may go here
          });
        })
        .catch((error) => {
          if (error.response.message.name[0])
          {
            const $toast = useToast();
            $toast.open({
              message: error.response.message.name[0],
              type: "danger",
              position: "top-right",
              // all of other options may go here
            });
          }
        });
    },
    async loadAttachment(model_id) {
      this.request.model_id = model_id;
      await httpauth
        .post("/attachments/show", this.request)
        .then((response) => {
          var data = response.data.data;
          this.attachments = data;
          this.loading = false;
          for (var i = 0; i < this.attachments.length; i++)
          {
            if (this.attachments[i].cover)
            {
              this.coverAttachment = this.attachments[i];
              this.attachments.splice(i, 1);
              break;
            }
          }
          const sortableList = this.$refs.sortableList;
          new Sortable(sortableList, {
            animation: 150,
            onEnd: (event) => {
              const movedItem = this.attachments.splice(event.oldIndex, 1)[0];
              this.attachments.splice(event.newIndex, 0, movedItem);
            },
          });
          // Gestisci l'array di oggetti come desiderato
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
        });
    },
    async fetchUsers() {
      await httpservices
        .getUserClinicalCase()
        .then((response) => {
          var users = response.data.data;
          this.users = users.map((user) => ({
            id: user.id,
            text: user.full_name,
          }));
          this.users.unshift({ id: "All", text: "A tutti gli utenti" });
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async update_clinical_case() {
      await httpauth
        .post("/casi-clinici/update", this.formClinicalCase)
        .then((response) => {
          const $toast = useToast();
          $toast.open({
            message: response.data.message,
            type: "info",
            position: "top-right",
            // all of other options may go here
          });
          if (this.formClinicalCase.slug != response.data.slug)
          {
            this.formClinicalCase.slug = response.data.slug;
            router.push(+"/casi-clinici/" + response.data.slug);
          }
        })
        .catch((error) => {
          this.errors = error.response.data.message;
        });
    },
    async handleFileUploadCover(event) {
      const maxSize = 1 * 512 * 512 * 512;
      const file = event.target.files[0];
      const totalSize = file.size;
      if (totalSize <= maxSize)
      {
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (allowedTypes.includes(file.type))
        {
          this.loading = true;
          const formData = new FormData();
          formData.append("model", "activity");
          formData.append("model_id", this.formClinicalCase.id);
          formData.append("cover", file);
          await httpauth
            .post("/attachments/cover/store", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              const $toast = useToast();
              this.loading = false;
              $toast.open({
                message: response.data.message,
                type: "success",
                position: "top-right",
              });
              this.coverAttachment = response.data.data;
            })
            .catch((error) => {
              if (error.response.message.cover[0])
              {
                const $toast = useToast();
                $toast.open({
                  message: error.response.message.cover[0],
                  type: "danger",
                  position: "top-right",
                  // all of other options may go here
                });
              }
            });
        }
      }
    },
    handleFileUpload(event) {
      const maxSize = 1 * 1024 * 1024 * 1024;
      const files = Array.from(event.target.files);
      const totalSize = files.reduce(
        (accumulator, file) => accumulator + file.size,
        0
      );
      const validFiles = [];
      if (totalSize <= maxSize)
      {
        const allowedTypes = [
          "application/pdf",
          "application/msword",
          "application/vnd.ms-office",
          "video/mp4",
          "image/jpeg",
          "image/png",
          "image/jpg",
          "application/dicom",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ];
        Array.from(files).forEach((file) => {
          // Esegui l'azione desiderata su ogni file
          if (
            !allowedTypes.includes(file.type) ||
            !httpservices.checkDicom(file)
          )
          {
            alert(
              "Per favore seleziona un file valido (PDF/DOC/DOCX/JPEG/JPG/PNG/MP4/DCM)."
            );
            this;
            return;
          }
          validFiles.push(file.name);
        });

        this.selectedFiles = files;
        this.nameFiles = validFiles.join(", ");
      } else
      {
        alert("La dimensione totale dei file supera 1 GB");
      }
    },
    async upload_attachments() {
      this.loading = true;
      await httpservices
        .uploadAttachments(
          this.selectedFiles,
          this.formClinicalCase.id,
          "activity",
          1,
          1
        )
        .then((response) => {
          console.log("entr");
          console.log(response.data);
          this.nameFiles = "Scegli i file (MAX 1 GIGA)";
          this.loading = false;
          this.success = response.data.message;
          this.attachments = response.data.data;
          const sortableList = this.$refs.sortableList;
          new Sortable(sortableList, {
            animation: 150,
            onEnd: (event) => {
              const movedItem = this.attachments.splice(event.oldIndex, 1)[0];
              this.attachments.splice(event.newIndex, 0, movedItem);
            },
          });
          return;
        })
        .catch(() => {
          this.loading = false;
          this.error = "Gli allegati non sono stati caricati";
        });
    },
    async deleteAttachment(attachmentId, index) {
      httpservices
        .deleteAttachment(attachmentId)
        .then((response) => {
          const $toast = useToast();
          $toast.open({
            message: response.data.message,
            type: "info",
            position: "top-right",
            // all of other options may go here
          });

          if (index >= 0)
          {
            this.attachments.splice(index, 1);
          } else
          {
            this.coverAttachment = null;
          }
        })
        .catch((error) => {
          if (error.response.message)
          {
            this.error = error.response.message;
          }
        });
    },
  },
};
</script>

<style scoped>
.btn-link {
  max-height: 40px;
}

.btn-link:hover {
  color: black !important;
  border-color: transparent;
}
</style>